import { ApiDataSourceSpec, apiDataSource } from "@/io/datasource/ApiDatasource.ts";
import { SupportInfo, supportInfoSchema } from "@/models/SupportInfoModel.ts";

export class ConfigRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  getSupportInfo = (): Promise<SupportInfo> => {
    return this.datasource.get("/config/", supportInfoSchema);
  };
}
